/**
 * Export — D3: JSONL canonical + Markdown on-demand. Anti-lock-in = brand (§4-zero):
 * a ogni milestone la domanda "l'utente porta via tutto?" ha risposta sì VERIFICATA da un test
 * (build plan §2 principio 5). Qui le funzioni pure; il download DOM vive in app.
 */
import type { HyprEvent } from "../storage/events";
import { compareEvents } from "../storage/events";

export { compareEvents };

export function toJsonl(events: HyprEvent[]): string {
  // lista vuota = JSONL vuoto (file senza righe), mai una riga vuota spuria
  if (events.length === 0) return "";
  const sorted = [...events].sort(compareEvents);
  return sorted.map((e) => JSON.stringify(e)).join("\n") + "\n";
}

export function jsonlFilename(now = new Date()): string {
  // D13: granularità settimanale `2026-Www.jsonl` = settimana ISO-8601 (anno ISO, non anno
  // civile: 2027-01-01 → `2026-W53`, 2026-01-03 → `2026-W01`). Algoritmo: la settimana
  // appartiene al suo giovedì (ISO 8601).
  const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  d.setUTCDate(d.getUTCDate() - ((d.getUTCDay() + 6) % 7) + 3); // giovedì della settimana ISO
  const year = d.getUTCFullYear();
  const firstThursday = new Date(Date.UTC(year, 0, 4));
  firstThursday.setUTCDate(firstThursday.getUTCDate() - ((firstThursday.getUTCDay() + 6) % 7) + 3);
  const week = 1 + Math.round((d.getTime() - firstThursday.getTime()) / (7 * 86_400_000));
  return `${year}-W${String(week).padStart(2, "0")}.jsonl`;
}

/**
 * MIME dell'export JSONL. `application/octet-stream` è DELIBERATO (bug device 2026-09-25):
 * con `application/x-ndjson` iOS rinominava il file in `2026-W39.jsonl.ndjson` — allinea
 * l'estensione al UTI del content-type e la APPENDE quando non coincide. Il nome è contratto
 * (D13: `2026-Wxx.jsonl`, un'unica estensione). `application/octet-stream` = dati generici,
 * nessuna estensione preferita da agganciare. NOTA: Playwright WebKit (harness) NON riproduce
 * la rinomina con nessun MIME — comportamento solo iOS (classe H6: il device è la gate).
 */
export const EXPORT_MIME = "application/octet-stream";

export function downloadText(filename: string, text: string, mime = EXPORT_MIME): void {
  const blob = new Blob([text], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/** File pronto per la condivisione (D50): nome D13 + MIME generico. */
export function jsonlFile(events: HyprEvent[], now = new Date()): File {
  return new File([toJsonl(events)], jsonlFilename(now), { type: EXPORT_MIME });
}

/**
 * D50: il foglio di condivisione si apre SOLO se il motore accetta proprio questo File.
 * Il gate è `canShare` (MDN: i tipi file accettati sono filtrati dalla piattaforma) — se dice
 * no, si cade sul download senza mai perdere l'export. Deterministico: mai eccezioni nude.
 */
export function canShareFile(file: File): boolean {
  try {
    return (
      typeof navigator.share === "function" &&
      typeof navigator.canShare === "function" &&
      navigator.canShare({ files: [file] })
    );
  } catch {
    return false;
  }
}
